angular.module('app.directives').directive('isAllowed', (UserService) => ({
    restrict: 'A',

    link(scope, element, attrs) {
        scope.$watch(attrs.isAllowed, (isAllowed) => {
            let permissions = {};

            // ujednolicony format: {key1: value1, key2: [value2, value3], ...}
            if ('string' === typeof isAllowed) {
                permissions = {};
                _.forEach((isAllowed || '').split('|'), (element) => {
                    permissions[element.replace(/\s+/g, '')] = 0;
                });
            } else if ('object' === typeof isAllowed) {
                permissions = isAllowed;
            }

            if (!UserService.isAllowed(permissions, scope.model ? scope.model.area_id : 0)) {
                element.hide();
            } else {
                element.show();
            }
        });
    },
}));
